import { useState } from "react";
import Head from "next/head";
import useUser from "../lib/useUser";
import { Layout } from "../common/Layout";
import { Imgix, Hero, Section } from "../common/UI";
import withSession from "../lib/session";
import {
  Container,
  Grid,
  Button,
  Box,
  Typography,
  Divider,
} from "@mui/material";

import { PartnersList } from "../modules/Partners/List";

export default function InstructorsPage() {
  return (
    <Layout>
      <Grid item>
        <Hero
          minHeight={400}
          bgImg="https://bigsurf1.imgix.net/zane_plus3_teaching1.jpg?w=1800"
        >
          <Box sx={{}}>
            <Typography
              variant="h2"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Instructors
            </Typography>
          </Box>
          <Box sx={{}}>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Helping you every step of your surf journey!
            </Typography>
          </Box>
        </Hero>

        <Section id="zane">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Zane Reed</Typography>
                  <Typography variant="h5">
                    Instructor, Owner of Big Surf Adventures
                  </Typography>
                  <p>
                    Zane Reed is the owner of Big Surf and one of our most
                    frequent instructors. Zane started Big Surf with a wealth of
                    knowledge and a diverse background: over 20 years of surfing
                    the West coast and various waves around the world, almost a
                    decade of coaching experience in tennis and lacrosse, as
                    well as holding numerous mentor, camp counselor, and
                    volunteer positions over the years. He pours his heart into
                    every lesson to give students a totally radical experience,
                    nurturing growth in the water, mind, and heart. He is a
                    proud new father, and has more than enough patience to meet
                    everyone's needs. Zane has lifeguard training and is CPR
                    Certified. On occasion when the waves are just right, Zane
                    will extend the lesson and surf side-by-side with students
                    as a bonus because he genuinely loves watching and teaching
                    people to learn to surf.
                  </p>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/443fc670-54df-4a36-b429-333b0c80857f.JPG"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="abraham">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Abraham Wolfinger</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    Father, coach, and local who was born and raised in Big Sur.
                    Master’s degree in education, currently teaching freshman at
                    Monterey Highschool. He has strong community values and
                    supports many local youth sports programs. Abraham says “I
                    aspire to unfold mind’s, and help people to reach their full
                    potential.” He’s surfed his whole life, and genuinely cares
                    about the sport while ushering in the next generation of
                    surfers. Inspired by the likes of Jacques Cousteau and Jack
                    Kerouac to become the adventurer he is today, Abraham often
                    says the ripples of our interactions and accomplishments
                    will touch the lives of people long after we are gone. He is
                    an amazing surfing instructor and is available most weekends
                    and evenings.
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/bcb2dd3b-f0b5-4a7c-84f0-ebd9863849e9.jpg"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="hector">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Héctor Mendieta</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    Héctor is originally from Chile, South America, and started
                    surfing in the cold waters of the South Pacific in the year
                    2000. He has had the privilege to live, travel, and surf in
                    several different countries, including Australia, New
                    Zealand, Indonesia, and Brazil, and has called California
                    home since 2018. Bilingual in English and Spanish (and
                    conversational Portuguese), Héctor is a language teacher at
                    the Salinas Union High School District as well as a surfing
                    instructor for Big Surf. He says, “For me, surfing is more
                    than just a sport or a hobby; it is a discipline that allows
                    you to express who you really are, and I try to pass that
                    knowledge to all my students, whether they're in or out of
                    the water.”
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/df2f08a0-218f-476f-95b7-df9b5ac9516b.JPG"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="samantha">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Samantha Waldroup</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    Samantha Waldroup is a passionate ocean steward and has been
                    surfing since the age of 9. She has 3 years of experience
                    with surf instructing, and has worked extensively with ocean
                    education programs for children relating to exploration,
                    safety, and board sport knowledge and is CPR/Lifeguard
                    Certified. She loves tailoring her teaching style to all
                    ages and experience levels, and is outgoing and
                    communicative throughout lessons. She loves helping students
                    achieve their surfing goals, watching them catch their first
                    wave, and sharing the stoke. She is currently pursuing a
                    Humanities & Communications degree at California State
                    University, Monterey Bay and hopes to continue surf
                    instructing for as long as she possibly can.
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/40464e83-760e-4a39-9c4f-0135e5a6d4fc.jpg"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="makena">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Makena Horne</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    I was raised by a meteorologist and a surfer, and I've been
                    surfing since before I could swim in Hawaii. I’ve since
                    continued surfing throughout my entire life, been teaching
                    surf lessons since I was just a child. It has flourished
                    into a wonderful career path for me!
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/1dfd3350-f04a-45b2-ae23-90218e7a25d0.JPG"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="kodey">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Kodey Sommer</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    I’m 19 years old and I love teaching people how to surf!
                    Surfing to me is so much fun, once you get to stand up on
                    the board it’s a feeling I can’t even describe, it just
                    makes you feel on top of the world. I am currently going to
                    college but also shredding waves any day I can!
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/5af1a5fb-26dd-4b86-9881-ee7e79a1995d.JPG"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="vanessa">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Vanessa Show</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    Vanessa Show has explored and surfed the California coast.
                    She previously lived in Humboldt County and Hawaii, but is
                    originally from Huntington Beach. Vanessa enjoys having an
                    active lifestyle and has a brown belt in Brazilian
                    jiu-jitsu. She was a jiu-jitsu coach before she transitioned
                    into education. She teaches 5th grade in Salinas and has a
                    passion for the community. Surfing is her favorite pastime,
                    and she loves sharing the love for the water with others.
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/d44a800e-7763-45c4-9579-bc7d306d959a.jpg"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="alex">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Alex Ahuja</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    Alex is a senior at Stevenson High School in Pebble Beach,
                    and he moved to Monterey Bay in 2014 from Tennessee. Since
                    the move the ocean has been a huge part of his life whether
                    it be surfing, freediving or fishing. He has been a surf
                    instructor for a combined two years from working as a camp
                    counselor and teaching for big surf. He also has experience
                    coaching lacrosse and football, and loves to share his
                    knowledge on the things that he loves with other people. His
                    goal while working at big surf is to spread the joy that
                    surfing brought him to new watermen and women across the
                    state.
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/c0f6406e-e1a3-4296-b8eb-792474197f1a.JPG"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="sean">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Sean Fanoe</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    I have been avidly surfing for over 5 years . I grew up in
                    the Monterey area and surfing has been one of the best parts
                    of my life. I love being in the water and going out to surf
                    with friends. I'm excited to educate and share my
                    experience/love of surfing with new students.
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/57b2cc93-7d58-4024-8df5-54822f39f21f.png"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Section id="antonio">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Typography variant="h4">Antonio Lisandro</Typography>
                  <Typography variant="h5">Instructor</Typography>
                  <p>
                    I’m Antonio and I’m an ISA certified surf coach. I love
                    teaching people how to surf, I’m a personal trainer and I
                    enjoy having an active lifestyle. I love teaching other
                    surfers how to improve their technique using effective
                    training such as surf skate, tactical fitness and steel mace
                    training systems. In my free time I volunteer at veterans
                    surf alliance sharing the stoke of surfing.
                  </p>
                </Box>
              </Grid>

              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/1074025a-958e-4d32-9b07-0c4ed0ea9b71.png"
                    width={800}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Hero minHeight={400} bg="#35baf6">
          <Typography
            variant="h2"
            sx={{
              color: "white",
              textShadow: "0 1px 0 black",
              textAlign: "center",
            }}
          >
            Whether it's your first time or you're eager to improve your skills,
            <br />
            Big Sur Surf Lessons will accommodate your learning needs!
          </Typography>
        </Hero>
      </Grid>
    </Layout>
  );
}

// export const getServerSideProps = withSession(async function ({ req, res }) {
//   const user = req.session.get("user") ?? null;
//   return {
//     props: { user },
//   };
// });
